<section class="masthead-page masthead-dieta-chetogenica montserrat">
    <p class="card-text montserrat text-center">DIETA CHETOGENICA</p>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="row">

        <div class="col-11 pt-5 pb-4">

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/"><i class="fa fa-home" aria-hidden="true"></i> Home</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Dieta Chetogenica</li>
                </ol>
            </nav>
    
        </div>

    </div>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="col-11 mt-3 marginauto">
        <div class="text text-justify pb-3">
            <div class="row">
                <div class="col mb-3">Protocolli chetogenici:</div>
            </div>
                <div class="row mb-5 text-xl-left text-lg-left text-md-center text-sm-center text-center">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">

                        <div class="list-group mb-2">
                            <a (click)="scrollTo('.alimentarsi-oggi')" class="list-group-item list-group-item-action list-group-item-success">Alimentarsi oggi</a>
                        </div>

                        <div class="list-group mb-2">
                            <a (click)="scrollTo('.vlckd')" class="list-group-item list-group-item-action list-group-item-success">VLCKD</a>
                        </div>
        
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">

                        <div class="list-group mb-2">
                            <a (click)="scrollTo('.lckd')" class="list-group-item list-group-item-action list-group-item-success">LCKD</a>
                        </div>
        
                        <div class="list-group mb-2">
                            <a (click)="scrollTo('.kd')" class="list-group-item list-group-item-action list-group-item-success">KD</a>
                        </div>
        
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
        
                        <div class="list-group mb-2">
                            <a (click)="scrollTo('.kn')" class="list-group-item list-group-item-action list-group-item-success">KN - Nutrizione chetogenica</a>
                        </div>
        
                        <div class="list-group mb-2">
                            <a (click)="scrollTo('.tdee')" class="list-group-item list-group-item-action list-group-item-success">CALCOLA IL TUO TDEE</a>
                        </div>

                    </div>

                </div>

                <div class="row mb-5 alimentarsi-oggi montserrat">
                    <div class="col">
                        <h2 class="mb-2">Alimentarsi oggi</h2>
                        <p>Ci sono tante persone che mangiano di tutto e liberamente, sono in buona forma fisica, analisi di laboratorio e esami clinici perfetti (del medico di fiducia non ricordano neanche il nome!) e non si pongono il problema di come e cosa mangiare semplicemente perché questo problema non lo conoscono, beati loro diremo!</p>
        
                        <p>Se siamo qui a parlare di nutrizione però è perché ce ne sono tante altre che invece sono in continua lotta con il piatto che hanno davanti e in varia misura presentano problemi legati ad una nutrizione scorretta o al peso eccessivo.</p>
        
                        <p>Basta guardarsi attorno per riconoscere quanto il problema sia grave, sovrappeso, obesità e patologie correlate sono diffusissimi, dal diabete 2 alla sindrome metabolica fino ad arrivare a malattie croniche e degenerative dove è determinante la responsabilità di un'alimentazione scorretta.</p>

                        <p>E le cose non starebbero così se le abitudini attuali funzionassero bene, saremmo tutti in perfetta forma e senza alcuna patologia correlata (dca a parte).</p>
        
                        <p>In attesa di una prossima revisione delle linee guida sulla nutrizione, in favore di differenti approcci nutrizionali ci sono di conforto la sperimentazione clinica e numerosi studi scientifici, mai potremmo valutare e proporre qualcosa di “diverso” o addirittura “estremo” se non avessimo il sostegno di una gran mole di evidenze scientifiche e di conferme cliniche sulla sua efficacia terapeutica.</p>
                        
                        <p>In tema di alimentazione il protocollo mediterraneo è l'ideale per la salute; in effetti sarebbe completo e salutare se non fosse per il fatto che le prime due regole basilari dello stesso non vengono rispettate se non in rarissimi casi.</p> 
                        
                        <p>In pratica infatti tranne chi svolge un lavoro fisicamente pesante e gli sportivi professionisti è raro riscontrare persone che si dedichino quotidianamente ad attività fisica tanto impegnativa da consumare la notevole quota di carboidrati prevista in dieta mediterranea.</p>
                        
                        <p>Altrettanto difficile è rispettare la seconda regola basilare che prevede l'assunzione di questa componente carboidratica da farine integrali ad elevato contenuto in fibre e nutrienti così come esistevano fino alla prima metà del secolo scorso; queste sono estremamente difficili da reperire sostituite invece da prodotti industriali ultra processati che delle caratteristiche nutritive e salutari originarie non hanno più nemmeno l'ombra. Per non parlare degli zuccheri aggiunti ormai ubiquitari che nulla hanno di salutare, tutt'altro!</p>
                        
                        <p>Eccessi, scarsa qualità e non ultima la sedentarietà, ecco i tre fattori sfortunati sui quali si costruisce buona parte del danno attuale!</p>

                        <p>Dobbiamo assolutamente fare qualcosa di diverso per incidere positivamente sulla salute di moltissimi con benefici incalcolabili da tutti i punti di vista.</p>
        
                        <p>Come?</p>
        
                        <p>Cambiando le abitudini e in particolare gli schemi nutrizionali attuali, lasciandoci dietro il così detto stile diabesogeno per abbracciarne altri più fortunati…la dieta del minestrone? Quella del fantino? La dieta dell'uva? La dieta ormonale? Pasta a colazione e aria la sera? Come mangiavano Fred e Wilma? Bibitoni e beveroni a vita?</p>
                        
                        <p>Scherzi a parte un approccio nutrizionale previsto in natura e studiato scientificamente già da un secolo per trattare specifiche patologie è quello chetogenico.</p>

                        <p>Quando non abbiamo a disposizione una quota sufficiente di carboidrati alimentari il nostro metabolismo utilizza a scopo energetico i grassi alimentari o quelli che abbiamo in forma di deposito.</p>
                        
                        <p>I corpi chetonici che derivano dalla trasformazione dei trigliceridi forniscono energia di grande qualità al cervello, al cuore, ai muscoli; ne sanno qualcosa i bambini epilettici farmaco resistenti, i pazienti affetti da deficit di GLUT1 che non possono metabolizzare gli zuccheri e tutti coloro che la seguono da anni per trattare specifiche patologie sensibili a questa alimentazione. Di ulteriore e prezioso conforto sono molti sportivi anche professionisti che ne traggono beneficio nella performance.</p>
                        
                        <p>Con queste premesse e con i casi di successo che ormai non si contano più, possiamo tranquillamente avvicinarci al metabolismo chetogenico senza alcun timore, si tratti di un percorso dietologico più o meno lungo o di un semplice approccio nuovo all'alimentazione per un benessere inaspettato.</p>
                        
                        <p>La dieta chetogenica ha delle limitazioni?<br>
                        Sì, ci sono alcune patologie dove è controindicato seguirla o dove è indispensabile la supervisione medica; a parte questi casi specifici il soggetto sano rischia molto di più infarto, ictus e tante altre malattie con un eccesso di carboidrati che non per un loro difetto.</p>

                        <p>La dieta chetogenica può portare danni a chi la segue?<br>
                        Ancora aspetto un caso clinico documentato e certificato dove un paziente in seguito a dieta chetogenica ben fatta abbia riportato lesioni di qualsiasi natura; all'opposto patologie anche gravissime da eccesso alimentare di carboidrati colpiscono tantissimi.</p>

                    </div>
                </div>

                <div class="row mb-5">
                    <div class="col">

                        <h2 class="mb-2">Protocolli chetogenici</h2>

                        <p><strong>PREMESSA</strong>: Dopo anni di trascuratezza o di eventi avversi che ci hanno costretto al rifugio nel cibo, la perdita di massa grassa superflua e dannosa non è sempre una passeggiata semplice, il percorso non è affatto lineare; pensate a un viottolo che scende da una montagna, ci saranno tratti molto scoscesi, tratti in pianura, ruscelli da saltare, punti in leggera risalita…se in “vetta” ci siamo stati fermi per anni e magari con molti problemi associati non si pensi di tornare a valle in un batter d'occhio, dovremo imparare nuovamente a muovere un passo dopo l'altro, a lungo, e nella giusta direzione!</p>

                        <p>Solo due concetti per capire di cosa parleremo:</p>

                        <ul>
                            <li>
                                riduzione drastica dell'introito di carboidrati 
                            </li>
                            <li>
                                totale calorico quotidiano.
                            </li>
                        </ul>

                        <p>La prima condizione induce il metabolismo chetogenico ed è imprescindibile, la seconda condizione decide se dimagriremo (dieta chetogenica ipocalorica) o se il peso resterà uguale (dieta chetogenica isocalorica o nutrizione chetogenica); ingrassare in chetogenica si può ma è impresa ardua.</p>

                        <p>Fissa la prima condizione ( la quota in carboidrati la consideriamo solitamente tra i 20 e i 50 grammi) le differenze tra i vari schemi dipenderanno esclusivamente dal totale calorico previsto nel piano nutrizionale personalizzato; gli standard numerici che seguiranno sono solo orientativi variando ben poco la sostanza se ci sono 100 calorie in più o in meno, tante sono poi le variabili soggettive da considerare volta per volta e che incidono sugli schemi alimentari.</p>

                    </div>
                </div>

            <div class="row mb-5">
                <div class="col vlckd">

                    <h3 class="mb-2">VLCKD</h3>
                    <p>Dieta chetogenica a bassissimo contenuto calorico.</p>

                    <p>Siamo intorno alle 500-700 Calorie giornaliere rappresentate essenzialmente dalla corretta percentuale proteica e da una minima quota di grassi (in aggiunta ai carboidrati già indicati). Sono protocolli estremi che richiedono particolare attenzione e la supervisione di una figura specialistica, si possono protrarre per periodi di tempo limitati, ripetibili ma con attenzione al possibile blocco da carestia. In questi protocolli lo stress metabolico e muscolare è notevole e sono fortemente indicate specifiche <a href="https://shop.leonelifestyle.com/?s=l-amino&jet_ajax_search_settings=%7B%22search_source%22%3A%22product%22%2C%22results_order_by%22%3A%22relevance%22%2C%22results_order%22%3A%22asc%22%7D&post_type=product" target="_blank"><strong>integrazioni proteiche</strong></a> di sintesi.</p>

                </div>
            </div>

            <div class="row mb-5">
                <div class="col lckd">

                    <h3 class="mb-2">LCKD</h3>
                    <p>Dieta chetogenica a basso contenuto calorico.</p>

                    <p>Siamo qui orientativamente tra le 800-1200 calorie giornaliere rappresentate sempre dalla corretta percentuale proteica e da una quota di grassi superiore a quella prevista per una vlckd. Anche in questo caso siamo di fronte a protocolli che richiedono particolare attenzione e possibilmente la supervisione di una figura specialistica, si possono protrarre per periodi di tempo più lunghi ma comunque intervallati da uno o più giorni di reinserimento di quote maggiori di carboidrati per evitare un possibile rallentamento metabolico da carestia.</p> 

                    <p>L'integrazione proteica di sintesi in questo caso è consigliabile ma non obbligatoria, molti soggetti posso procedere perfettamente utilizzando solo cibi naturali.</p>

                </div>
            </div>

            <div class="row mb-5">
                <div class="col kd">

                    <h3 class="mb-2">KD</h3>
                    Dieta chetogenica a contenuto calorico ridotto.
                    In questo caso la riduzione calorica si attesta intorno ad un 20% circa del dispendio calorico quotidiano; questo protocollo induce un dimagrimento più lento nel tempo ma il rischio di un rallentamento metabolico è più ridotto. Si possono raggiungere risultati di dimagrimento soddisfacente a patto che l'organismo sia in perfetto equilibrio metabolico e ormonale.

                </div>
            </div>

            <div class="row mb-5">
                <div class="col kn">

                    <h3 class="mb-2">KN - Nutrizione chetogenica</h3>
                    <p>Dieta chetogenica isocalorica, non si dimagrisce.</p>
                    
                    <p>In questo caso non è prevista una riduzione calorica ma il totale dei macronutrienti copre il totale del fabbisogno calorico quotidiano; la principale fonte di energia è rappresentata dai grassi assunti con la dieta, tanti ne mangiamo tanti ne consumiamo e il peso corporeo si mantiene uguale.</p>

                    <p>Ad un primo approccio potrà sembrare strano segnalare la nutrizione chetogenica tra le diete ma questo “comportamento alimentare” se protratto a lungo termine (alcuni inorridiscono al concetto di stile di vita ma di questo in realtà si tratta) ha delle grandi potenzialità in prevenzione e terapia per molte malattie acute nonché cronico-degenerative legate all'età.</p> 
                    
                    <p>Se è vero che si può dimagrire in tanti modi e anche con la ben conosciuta dieta chetogenica, la nutrizione chetogenica è un'assoluta novità da valutare attentamente nella scelta di una sana alimentazione; se seguita correttamente e integrata dove necessario (sport, terza età) non comporta alcuno squilibrio metabolico e nutrizionale al contrario di quanto invece solitamente accade con un uso quotidiano e abbondante di farine raffinate (pane, pasta, merendine).</p>
                    
                    <p class='alert alert-warning mt-3 mb-3' role='alert'>N.B: in nutrizione chetogenica nel soggetto sano non è precluso in alcun modo aumentare le quote di carboidrati ma più sarà raro questo comportamento più si manterrà e si beneficerà nel tempo dei vantaggi del metabolismo chetogenico.</p>

                </div>

            </div>

            <div class="row mb-5 tdee">
                <div class="col">

                    <h3 class="mb-2">CALCOLA IL TUO TDEE</h3>
                    <p>Il consumo energetico giornaliero complessivo o TDEE (Total Daily Energy Expenditure cioè la spesa energetica giornaliera totale) è una stima di quante calorie bruciamo giornalmente. E' un dato importante da conoscere per impostare successivamente il deficit calorico corretto per il nostro percorso dietetico.</p>

                    <div id="tdee_widget_code"></div>

                </div>
            </div>

        </div>
    </div>

    <div class="col-11 pt-5 pb-4">

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Dieta Chetogenica</li>
            </ol>
        </nav>

    </div>


</section>

<section class="py-3"></section>
